import * as React from "react"
import { useLocation, useNavigate } from "react-router-dom"

import completeEmailConfirmation from "@podcastsoundboard/ps-lib/api/auth/confirmEmail"
import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer"

import AppBar from "../../components/AppBar"
import Copyright from "../../components/Copyright"
import { useAppDispatch, useAppSelector } from "../../redux"
import { addSnackbar } from "../../redux/snackbars"
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Stack,
  Toolbar,
  Typography,
  AlertColor,
} from "@podcastsoundboard/ps-lib/ui"

export default function CompleteConfirmEmail() {
  const dispatch = useAppDispatch()
  const { search } = useLocation()
  const navigate = useNavigate()

  const [submitting, setSubmitting] = React.useState(true)

  const [errorMessage, setErrorMessage] = React.useState("")
  const [messageSeverity, setMessageSeverity] =
    React.useState<AlertColor>("error")

  const handleCompleteEmailConfirmation = () => {
    setSubmitting(true)
    const params = new URLSearchParams(search)
    const token = params.get("token")
    const email = params.get("email")

    if (!email) return setErrorMessage("No email provided")
    if (!token) return setErrorMessage("No token provided")

    completeEmailConfirmation(email, token)
      .then(() => {
        setSubmitting(false)

        dispatch(
          addSnackbar({
            id: "emailconfirmsuccess",
            text: "Email confirmation successful.",
          }),
        )

        navigate("/app/signin")
      })
      .catch((err) => {
        console.error(err)
        setSubmitting(false)
        setMessageSeverity("error")
        setErrorMessage(
          (err.response?.data as { error?: string } | undefined)?.error ||
            err.message,
        )
      })
  }

  React.useEffect(() => {
    handleCompleteEmailConfirmation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  return (
    <PageContainer darkModeEnabled={darkModeEnabled} className="min-h-screen">
      <AppBar title="Podcast Soundboard" />

      <Toolbar />

      {errorMessage && (
        <Stack className="w-full" spacing={2}>
          <Alert className="rounded-none" severity={messageSeverity}>
            {errorMessage}
          </Alert>
        </Stack>
      )}

      <Container component="main" maxWidth="xs">
        <Box className="mt-8 flex flex-col items-center">
          <Typography component="h1" variant="h5" color="text.primary">
            Confirming email...
          </Typography>

          <Box className="mt-6">
            {submitting && (
              <Box className="flex justify-center">
                <CircularProgress />
              </Box>
            )}
          </Box>
        </Box>

        <Copyright className="mt-10" />
      </Container>
    </PageContainer>
  )
}
